import { useEffect, useState } from 'react';
import { fetchFinalRates as fetchFinalRatesApi, fetchInstantLinkInfo, markLinkClicked } from "../../../../../api/requests/payment-requests";

export default function useLinkData(linkId, validation, selectedInstallment, formatTRY, getTotalWithCommission) {
    const [pageLoading, setPageLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [linkData, setLinkData] = useState(null);
    const [finalRates, setFinalRates] = useState({ usdFinalRate: null, eurFinalRate: null, gbpFinalRate: null });
    const [contractText, setContractText] = useState('');

    useEffect(() => {
        let cancelled = false;

        const fetchFinalRates = async (companyId) => {
            if (!companyId) return;
            try {
                const res = await fetchFinalRatesApi(companyId);
                if (!res.ok) throw new Error();
                const { data } = await res.json();
                if (!cancelled) {
                    setFinalRates(data || { usdFinalRate: null, eurFinalRate: null, gbpFinalRate: null });
                }
            } catch {}
        };

        const load = async () => {
            setPageLoading(true);
            setErrorMessage('');
            if (!linkId) {
                setErrorMessage('Geçersiz ödeme bağlantısı.');
                setPageLoading(false);
                return;
            }
            try {
                const linkResp = await fetchInstantLinkInfo(linkId);
                if (linkResp.status === 410) {
                    setErrorMessage('Bu ödeme bağlantısının süresi dolmuştur veya bağlantı yayından kaldırılmıştır.');
                    setPageLoading(false);
                    return;
                }
                const wrapper = await linkResp.json();
                if (linkResp.ok && wrapper.statusCode === 200) {
                    const d = wrapper.data;
                    if (d.expiryDate && new Date(d.expiryDate) < new Date()) {
                        setErrorMessage('Bu ödeme bağlantısının süresi dolmuştur.');
                        return;
                    }
                    const finalLinkData = { ...d, installmentRates: d.accountGroup?.installmentRates, cardsMaxInstallments: d.cardsMaxInstallments };
                    setLinkData(finalLinkData);

                    // Only set amount if validation is available
                    if (validation && d.fixedAmount != null) {
                        const amt = Number(d.fixedAmount);
                        validation.setFieldValue('amount', amt.toFixed(2));
                    }

                    if (d.companyContract) setContractText(d.companyContract);

                    fetchFinalRates(d.accountGroup?.companyId);
                    markLinkClicked(linkId).catch(() => {});
                } else {
                    setErrorMessage(wrapper.message || 'Link bulunamadı.');
                }
            } catch (error) {
                console.error('Link loading error:', error);
                setErrorMessage('Ödeme bağlantısı yüklenirken hata oluştu.');
            } finally {
                if (!cancelled) setPageLoading(false);
            }
        };

        load();
        return () => { cancelled = true; };
    }, [linkId]); // Only linkId as dependency

    // Separate effect for handling fixed amount when validation becomes available
    useEffect(() => {
        if (validation && linkData?.fixedAmount != null) {
            const amt = Number(linkData.fixedAmount);
            validation.setFieldValue('amount', amt.toFixed(2));
        }
    }, [validation, linkData?.fixedAmount]);

    return { pageLoading, errorMessage, setErrorMessage, linkData, setLinkData, finalRates, contractText, setContractText };
}